export default {"src":"/_next/static/media/logo-avis.fbf8e25f.svg","height":14,"width":44,"blurWidth":0,"blurHeight":0};